
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 20H2a2 2 0 01-2-2V6a1 1 0 011-1h3a5 5 0 1110 0h3a1 1 0 011 1v12a2 2 0 01-2 2zM2 7v11h14V7h-2v1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7H6v1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7H2zm7-5a3 3 0 00-3 3h6a3 3 0 00-3-3z"}})])
          )
        }
      }
    